/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Import_AbortedInputs */

const en_issue_import_aborted = /** @type {(inputs: Issue_Import_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the import stopped before the end: try again`)
};

/**
* | output |
* | --- |
* | "the import stopped before the end: try again" |
*
* @param {Issue_Import_AbortedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_import_aborted = /** @type {((inputs?: Issue_Import_AbortedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Import_AbortedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_import_aborted(inputs)
});